/**
 * Two designs, one app. The skin is chosen by the domain the site is loaded on:
 *   carfornia.info            -> "dark"   (quiet-premium design)
 *   carforniabuyers.com, else -> "classic" (blue-and-white design)
 * Public entry: carfornia.info forwards (GoDaddy) to https://carforniabuyers.com/?ref=info — the
 * param selects the dark design, is remembered for the visit, and is stripped from the address bar.
 * Internal override for previews/testing: ?skin=dark or ?skin=classic (remembered in sessionStorage).
 */
export const DARK_HOSTS = ["carfornia.info", "www.carfornia.info"];
const PUBLIC_REFS = { info: "dark" };

function stripParams(url, keys) {
  keys.forEach((k) => url.searchParams.delete(k));
  window.history.replaceState(null, "", url.pathname + (url.search || "") + url.hash);
}

export function getSkin() {
  if (typeof window === "undefined") return "classic";
  const url = new URL(window.location.href);
  const ref = url.searchParams.get("ref");
  if (PUBLIC_REFS[ref]) {
    sessionStorage.setItem("carfornia_skin", PUBLIC_REFS[ref]);
    stripParams(url, ["ref"]);
    return PUBLIC_REFS[ref];
  }
  const q = url.searchParams.get("skin");
  if (q === "dark" || q === "classic") {
    sessionStorage.setItem("carfornia_skin", q);
    return q;
  }
  const saved = sessionStorage.getItem("carfornia_skin");
  if (saved) return saved;
  return DARK_HOSTS.includes(window.location.hostname) ? "dark" : "classic";
}

export const useSkin = () => getSkin();

export const siteSource = () => (getSkin() === "dark" ? "carfornia.info" : "carforniabuyers.com");
